import React, { FC } from 'react'
import './group-banner-create.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    currentStep: number,
}

const GroupBannerCreate: FC<Props> = (props) => {
    const { className: classProp, currentStep, ...divProps } = props
    const className = flatten('group-banner-create', classProp)

    return (
        <div className={className} {...divProps}>
            <h1><strong>Create a Group Card</strong></h1>
        </div>
    )
}

export default GroupBannerCreate